// External Imports
import { useContext } from "react";
import { MdHistory } from "react-icons/md";

// Internal Imports
import { UtilityContext } from "../../context/util-context";

/** ========================================================================
 * * AuditLogs Component
 * This component renders a button that navigates to the logs for the record.
 * ========================================================================== */

export default function AuditLogs({ classes, table, id }) {
  const { navigate } = useContext(UtilityContext);
  return (
    <MdHistory
      className={classes || "icon"}
      onClick={(e) =>
        navigate(
          `/audits?sd=&ed=&table=${table}&action=All&agent=All&query=${id}&`,
          e,
        )
      }
      title="View Logs"
    />
  );
}
